export default __webpack_public_path__ + "static/media/contact_mail.cdc8fb10.png";